<div class="generic-select-wrapper">
    <p-select #genericSelect
              stopOnOptionSelectPropagation
              [id]="id"
              [options]="options"
              [placeholder]="config.placeholder || placeholder"
              [class.hide-placeholder]="config.placeholderSubstitute && !value && placeholderSubstituteTemplate"
              optionLabel="label"
              optionValue="value"
              [disabled]="disabled"
              [filter]="filter"
              filterBy="label"
              (onFilter)="onFilter($event)"
              [virtualScroll]="virtualScroll && !isStaticMode"
              [lazy]="lazy && !isStaticMode"
              [virtualScrollItemSize]="virtualScrollItemSize"
              [virtualScrollOptions]="virtualScrollOptions"
              [loading]="loading"
              [appendTo]="appendTo"
              [styleClass]="styleClass"
              [showClear]="showClear"
              [ngModel]="value"
              (ngModelChange)="onValueChange($event)">

        <!-- Custom templates -->
        <ng-template let-item pTemplate="selectedItem">
            <ng-container *ngIf="selectedItemTemplate; else builtInSelectedItem">
                <ng-container *ngTemplateOutlet="selectedItemTemplate; context: { $implicit: item }"></ng-container>
            </ng-container>
            <ng-template #builtInSelectedItem>
                <ng-container [ngSwitch]="config.templateName">
                    <!-- Employee template -->
                    <div *ngSwitchCase="'employee'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.code" severity="secondary" />
                        <div>{{ item.fullname }} ({{ item.nickname }})</div>
                    </div>
                    <!-- Position template -->
                    <div *ngSwitchCase="'position'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.departmentName" severity="secondary" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Department template -->
                    <div *ngSwitchCase="'department'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.code" severity="secondary" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Room template -->
                    <div *ngSwitchCase="'room'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.center.code"
                                       [tagColor]="item.center.tagColor"
                                       [tagTextColor]="item.center.tagTextColor" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Center template -->
                    <div *ngSwitchCase="'center'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.code"
                                       [tagColor]="item.tagColor"
                                       [tagTextColor]="item.tagTextColor" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Role template -->
                    <div *ngSwitchCase="'role'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.code" severity="secondary" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Course template -->
                    <div *ngSwitchCase="'course'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.type" severity="info" />
                        <div>{{ item.name }}</div>
                        <p-tag [value]="item.level" severity="secondary" />
                        <div class="ml-auto italic">{{ item.teacher }}</div>
                    </div>
                    <!-- Employee Position template -->
                    <div *ngSwitchCase="'employeePosition'" class="flex items-center gap-2 w-full">
                        <div>{{ item.positionName || 'N/A' }}</div>
                        <generic-p-tag [value]="item.status || 'N/A'" type="employeePositionStatus" styleClass="w-fit" />
                        <div class="text-sm italic">{{ ((item.fromDate | date:'dd/MM/yyyy') || '') + ' - ' + ((item.toDate | date:'dd/MM/yyyy') || '')}}</div>
                    </div>
                    <!-- Session Status template -->
                    <div *ngSwitchCase="'sessionStatus'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.value" type="sessionStatus" styleClass="w-fit" />
                    </div>
                    <!-- Study Plan Status template -->
                    <div *ngSwitchCase="'studyPlanStatus'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.value" type="studyPlanStatus" styleClass="w-fit" />
                    </div>
                    <!-- Study Plan template -->
                    <div *ngSwitchCase="'studyPlan'" class="flex items-center justify-between gap-2 w-full">
                        <div class="text-sm">{{ (item.startDate | date:'dd/MM/yyyy') || '' }} - {{ (item.endDate | date:'dd/MM/yyyy') || '(ongoing)' }}</div>
                        <generic-p-tag [value]="item.status" type="studyPlanStatus" styleClass="w-fit" />
                    </div>
                    <!-- employeePositionWithNames template -->
                    <div *ngSwitchCase="'employeePositionWithNames'" class="flex items-center justify-between gap-2 w-full">
                        <div class="flex items-center gap-2">
                            <div>{{ item.employee?.nickname || 'N/A' }}</div>
                            <div class="text-sm text-gray-600">{{ item.position?.name || 'N/A' }}</div>
                        </div>
                        <div class="flex items-center gap-2">
                            <generic-p-tag [value]="item.status" type="employeePositionStatus" styleClass="w-fit" />
                            <div class="text-xs italic">{{ ((item.fromDate | date:'dd/MM/yyyy') || '') + ' - ' + ((item.toDate | date:'dd/MM/yyyy') || 'Hiện tại')}}</div>
                        </div>
                    </div>
                    <!-- Ticket Type template -->
                    <div *ngSwitchCase="'ticketType'" class="flex items-center gap-2 w-full">
                        <p-tag [styleClass]="item.cssClass + ' flex items-center gap-1'">
                            <span>{{ item.label }}</span>
                            <i class="pi pi-chevron-down text-xs"></i>
                        </p-tag>
                    </div>
                    <!-- Ticket Status template -->
                    <div *ngSwitchCase="'ticketStatus'" class="flex items-center gap-2 w-full">
                        <p-tag [styleClass]="item.cssClass + ' flex items-center gap-1'">
                            <span>{{ item.label }}</span>
                            <i class="pi pi-chevron-down text-xs"></i>
                        </p-tag>
                    </div>
                    <!-- Assignee template -->
                    <div *ngSwitchCase="'assignee'" class="flex items-center justify-between gap-2 w-full">
                        <div class="rounded-full bg-primary text-white flex items-center justify-center font-semibold w-8 h-8 text-xs">
                            {{ getUserInitials(item) }}
                        </div>
                    </div>
                    <!-- Default template -->
                    <div *ngSwitchDefault>{{ item.label }}</div>
                </ng-container>
            </ng-template>
        </ng-template>

        <ng-template let-item #item>
            <ng-container *ngIf="itemTemplate; else builtInItem">
                <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
            </ng-container>
            <ng-template #builtInItem>
                <ng-container [ngSwitch]="config.templateName">
                    <!-- Employee template -->
                    <div *ngSwitchCase="'employee'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.code" severity="secondary" />
                        <div>{{ item.fullname }} {{ item.nickname ? ' (' + item.nickname + ')' : '' }}</div>
                    </div>
                    <!-- Position template -->
                    <div *ngSwitchCase="'position'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.departmentName" severity="secondary" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Department template -->
                    <div *ngSwitchCase="'department'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.code" severity="secondary" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Room template -->
                    <div *ngSwitchCase="'room'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.center.code"
                                       [tagColor]="item.center.tagColor"
                                       [tagTextColor]="item.center.tagTextColor" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Center template -->
                    <div *ngSwitchCase="'center'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.code"
                                       [tagColor]="item.tagColor"
                                       [tagTextColor]="item.tagTextColor" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Role template -->
                    <div *ngSwitchCase="'role'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.code" severity="secondary" />
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- Course template -->
                    <div *ngSwitchCase="'course'" class="flex items-center gap-2 w-full">
                        <p-tag [value]="item.type" severity="info" />
                        <div>{{ item.name }}</div>
                        <p-tag [value]="item.level" severity="secondary" />
                        <div class="ml-auto italic">{{ item.teacher }}</div>
                    </div>
                    <!-- Employee Position template -->
                    <div *ngSwitchCase="'employeePosition'" class="flex items-center gap-2 w-full">
                        <div>{{ item.positionName || 'N/A' }}</div>
                        <generic-p-tag [value]="item.status || 'N/A'" type="employeePositionStatus" styleClass="w-fit" />
                        <div class="text-sm italic">{{ ((item.fromDate | date:'dd/MM/yyyy') || '') + ' - ' + ((item.toDate | date:'dd/MM/yyyy') || '')}}</div>
                    </div>
                    <!-- Session Status template -->
                    <div *ngSwitchCase="'sessionStatus'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.value" type="sessionStatus" styleClass="w-fit" />
                    </div>
                    <!-- Study Plan Status template -->
                    <div *ngSwitchCase="'studyPlanStatus'" class="flex items-center gap-2 w-full">
                        <generic-p-tag [value]="item.value" type="studyPlanStatus" styleClass="w-fit" />
                    </div>
                    <!-- Study Plan template -->
                    <div *ngSwitchCase="'studyPlan'" class="flex items-center justify-between gap-2 w-full">
                        <div class="text-sm">{{ (item.startDate | date:'dd/MM/yyyy') || '' }} - {{ (item.endDate | date:'dd/MM/yyyy') || '(ongoing)' }}</div>
                        <generic-p-tag [value]="item.status" type="studyPlanStatus" styleClass="w-fit" />
                    </div>
                    <!-- employeePositionWithNames template -->
                    <div *ngSwitchCase="'employeePositionWithNames'" class="flex items-center justify-between gap-2 w-full">
                        <div class="flex items-center gap-2">
                            <div class="font-semibold">{{ item.employee?.nickname || 'N/A' }}</div>
                            <div class="text-sm text-gray-600">{{ item.position?.name || 'N/A' }}</div>
                        </div>
                        <div class="flex items-center gap-2">
                            <generic-p-tag [value]="item.status" type="employeePositionStatus" styleClass="w-fit" />
                            <div class="text-xs italic">{{ ((item.fromDate | date:'dd/MM/yyyy') || '') + ' - ' + ((item.toDate | date:'dd/MM/yyyy') || 'Hiện tại')}}</div>
                        </div>
                    </div>
                    <!-- Ticket Type template -->
                    <div *ngSwitchCase="'ticketType'" class="flex items-center gap-2 w-full">
                        <p-tag [styleClass]="item.cssClass + ' flex items-center gap-1'">
                            <span>{{ item.label }}</span>
                        </p-tag>
                    </div>
                    <!-- Ticket Status template -->
                    <div *ngSwitchCase="'ticketStatus'" class="flex items-center gap-2 w-full">
                        <p-tag [styleClass]="item.cssClass + ' flex items-center gap-1'">
                            <span>{{ item.label }}</span>
                        </p-tag>
                    </div>
                    <!-- Assignee template -->
                    <div *ngSwitchCase="'assignee'" class="flex items-center justify-between gap-2 w-full">
                        <div class="flex items-center gap-2">
                            <p-tag [value]="item.code" severity="success" />
                            <span>{{ item.fullname || 'N/A' }}</span>
                        </div>
                        <span class="italic text-gray-600">{{ item.nickname }}</span>
                    </div>
                    <!-- Default template -->
                    <div *ngSwitchDefault>{{ item.label }}</div>
                </ng-container>
            </ng-template>
        </ng-template>

        <ng-template #empty>
            <ng-container *ngIf="loading; else noResults">
                <span class="italic">Loading — please wait…</span>
            </ng-container>
            <ng-template #noResults>
                <span class="italic">No results found.</span>
            </ng-template>
        </ng-template>
    </p-select>

    <!-- Placeholder Substitute Template -->
    <ng-container *ngIf="config.placeholderSubstitute && !value && placeholderSubstituteTemplate">
        <div class="placeholder-substitute">
            <ng-container *ngTemplateOutlet="placeholderSubstituteTemplate"></ng-container>
        </div>
    </ng-container>
</div>